import emptySplitApi from "../utils/rtk";
import { END_POINTS } from "../helpers";
import { CommonBody } from "../types/General";

type CommonResponseType = {
  statusCode: number;
  message: string;
  s3Location?: string;
};

export const bannerApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllBanner: builder.query<
      CommonResponseType & { data: any },
      {
        page?: number;
        search?: string;
      }
    >({
      query: ({ page, search }) => {
        let url = `${END_POINTS.getAllBanner}?page=${page}&search=${search}`;

        return {
          url: url,
          method: "GET",
        };
      },
    }),
    getBannerById: builder.query<
      CommonResponseType & { data: any },
      { id: any }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getBannerById}/${id}/`,
        method: "GET",
      }),
    }),
    addBanner: builder.mutation<
      CommonResponseType & { data: CommonBody },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: `${END_POINTS.addBanner}`,
        method: "POST",
        body,
      }),
    }),
    updateBanner: builder.mutation<
      CommonResponseType & { data: CommonBody },
      { id: string | undefined; body: CommonBody }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateBanner}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    deleteByIdBanner: builder.mutation<
      CommonResponseType & { data: any },
      { id: any }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteByIdBanner}/${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useAddBannerMutation,
  useUpdateBannerMutation,
  useDeleteByIdBannerMutation,
  useLazyGetAllBannerQuery,
  useLazyGetBannerByIdQuery,
} = bannerApi;
